import Vue from 'vue';
import Axios from 'axios';
import { token } from "@/services/TokenService";
import { URL_BASE, LANG } from '@/defaults';
import { decryptInterceptor } from "@/utils/decryptInterceptor";



const instance = Axios.create({
  baseURL: URL_BASE,
  headers: {
    common: {
      'X-Requested-With': 'XMLHttpRequest',
    }
  }
});


instance.interceptors.request.use(config => {
  config.headers = {
    'Accept-Language': localStorage.getItem('lang') ? localStorage.getItem('lang') : LANG,
  };

  if (token.Get()) {
    config.headers.act = token.Get()
  }

  return config;
}, error => Promise.reject(error));


instance.interceptors.response.use(response => {
  return decryptInterceptor(response)
}, error => {
  if (error.response && error.response.status === 401) {
    token.GoToLogin()
  }
  if (error) {
    if (error.response) {
      if (error.response.data) {
        if (error.response.data.error_message) {
          // notification.error(error.response.data.error_message.title);
        }
      }
    }
  }

  return Promise.reject(error);
});


Vue.prototype.$api = instance;
export default instance;
// Vue.prototype.$http = instance;
